import { fetchAuthSession } from "aws-amplify/auth";
import { post, put, del } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import { MEDICAL_CONDITIONS_QUERY_KEY } from "./useMedicalConditionQuery";

export const useMedicalConditionPostMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (medicalConditionFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "hrmedicalconditionapi",
        path: `/medical-conditions`,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: medicalConditionFormInputs,
        },
      }).response;
      return (await body?.json()) || {};
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [MEDICAL_CONDITIONS_QUERY_KEY],
      });
    },
  });
};

export const useMedicalConditionPutMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (medicalConditionFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "hrmedicalconditionapi",
        path: "/medical-conditions",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: medicalConditionFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MEDICAL_CONDITIONS_QUERY_KEY],
      });
    },
  });
};

export const useMedicalConditionDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: "hrmedicalconditionapi",
        path: "/medical-conditions",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: { id: id },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [MEDICAL_CONDITIONS_QUERY_KEY],
      });
    },
  });
};
